// extracted by mini-css-extract-plugin
module.exports = {"root":"menu_root__2SAlT","left":"menu_left__2fOJf","right":"menu_right__4am3g","menuBtn":"menu_menuBtn__2VxTN button_buttonTransparent__7YN1o","userName":"menu_userName__33y1W"};